import { useGetSupportTicketsInfiniteQuery } from "entities/support-ticket";
import { toInfiniteListState } from "shared/ui";
import type { StatusFilter } from "./statusFilters";

export const useTicketsList = (filter: StatusFilter) => {
  // «Все» — запрос без status; список свежий при каждом открытии.
  const result = useGetSupportTicketsInfiniteQuery(
    filter === "all" ? {} : { status: filter },
    { refetchOnMountOrArgChange: true },
  );

  return toInfiniteListState(result, (page) => page.tickets);
};
